import { motion } from 'framer-motion';

const stages = [
  {
    num: '01',
    name: 'Strategic Discovery',
    desc: 'Confidential scoping of objectives, constraints, and organisational context to determine fit and engagement structure.',
  },
  {
    num: '02',
    name: 'Intelligence Assessment',
    desc: 'Diagnostic evaluation of operational maturity, AI readiness, decision architecture, and strategic positioning.',
  },
  {
    num: '03',
    name: 'Strategic Architecture',
    desc: 'Design of transformation pathways, intelligence systems, governance frameworks, and implementation roadmaps.',
  },
  {
    num: '04',
    name: 'Long-Horizon Evolution',
    desc: 'Continuous intelligence, drift detection, quarterly reviews, and adaptive strategy refinement over time.',
  },
];

const EngagementProcess = () => {
  return (
    <section className="relative py-16 lg:py-20" data-testid="engagement-process">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <p className="text-xs uppercase tracking-[0.3em] mb-3" style={{ color: 'rgba(201,162,39,0.5)' }}>
            Engagement Structure
          </p>
          <h3
            className="text-xl md:text-2xl font-light tracking-[0.1em] text-white"
            style={{ fontFamily: "'Cinzel', serif" }}
          >
            How Engagement Begins
          </h3>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-5">
          {stages.map((s, i) => (
            <motion.div
              key={s.num}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="relative p-6"
              style={{
                background: 'rgba(10,22,40,0.35)',
                border: '1px solid rgba(201,162,39,0.1)',
                borderRadius: '4px',
              }}
              data-testid={`engagement-stage-${s.num}`}
            >
              <span
                className="text-3xl font-light mb-3 block"
                style={{ color: 'rgba(201,162,39,0.15)', fontFamily: "'Cinzel', serif" }}
              >
                {s.num}
              </span>
              <h4
                className="text-xs uppercase tracking-[0.15em] mb-3"
                style={{ color: '#c9a227', fontFamily: "'Cinzel', serif" }}
              >
                {s.name}
              </h4>
              <p className="text-sm leading-relaxed" style={{ color: 'rgba(255,255,255,0.5)' }}>
                {s.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EngagementProcess;
